import React from 'react';
import { ArrowRightIcon, CheckIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
import { pricingTiers } from '../../data/site';
export function PricingTiers() {
  return <ul className="mt-12 grid gap-6 lg:grid-cols-3" data-id="element-208" data-mp="1i4dcw4ekcx2t">
      {pricingTiers.map(tier => <li key={tier.name} className={`flex flex-col rounded-brand p-8 ${tier.accent ? 'bg-ink text-cream' : 'border border-ink/10 bg-cream-light'}`} data-id="element-209" data-mp="1d5sdg774yhff">
          <div className="flex items-center justify-between gap-3" data-id="element-210" data-mp="25uh93qpf9ujs">
            <h3 className={`text-[0.6875rem] uppercase tracking-label ${tier.accent ? 'text-copper' : 'text-ink-muted'}`} data-id="element-211" data-mp="25s3grpm4mwfx">
              {tier.name}
            </h3>
            {tier.accent && <span className="rounded-full bg-copper px-3 py-1 text-[0.625rem] uppercase tracking-label text-ink" data-id="element-212" data-mp="pgzbnu3u1fcw">
Most popular
              </span>}
          </div>

          <p className="mt-6 flex items-baseline gap-2" data-id="element-213" data-mp="13cocl4wo5gtp">
            <span className={`font-serif text-5xl font-bold ${tier.accent ? 'text-cream' : 'text-ink'}`} data-id="element-214" data-mp="13b3ckzrl55og">
              ${tier.price}
            </span>
            <span className={`text-sm ${tier.accent ? 'text-cream/70' : 'text-ink-muted'}`} data-id="element-215" data-mp="tei76dbnlsk3">
              {tier.cadence}
            </span>
          </p>
          <p className={`mt-4 text-sm leading-relaxed ${tier.accent ? 'text-cream/70' : 'text-ink-soft'}`} data-id="element-216" data-mp="jooypl6t5tk2">
            {tier.description}
          </p>

          <ul className="mt-7 flex flex-col gap-3" data-id="element-217" data-mp="ap24bjchxo0i">
            {tier.features.map(feature => <li key={feature} className="flex items-start gap-3" data-id="element-218" data-mp="fmty6iwpbk7c">
                <CheckIcon className={`mt-0.5 h-4 w-4 shrink-0 ${tier.accent ? 'text-copper' : 'text-brick'}`} strokeWidth={2.25} data-id="element-219" data-mp="qcnltwc69lu" />
                <span className={`text-sm leading-relaxed ${tier.accent ? 'text-cream/80' : 'text-ink-soft'}`} data-id="element-220" data-mp="5rjttoitz0qe">
                  {feature}
                </span>
              </li>)}
          </ul>

          <Link to="/get-started" className={`group mt-auto inline-flex items-center justify-center gap-2 rounded-full pt-0 text-sm font-medium transition-colors duration-150 ease-republic ${tier.accent ? 'mt-8 bg-cream px-6 py-3 text-ink hover:bg-copper' : 'mt-8 border border-ink/20 px-6 py-3 text-ink hover:border-ink hover:bg-ink hover:text-cream'}`} data-id="element-221" data-mp="390op4brpovbj">
            Choose this
            <ArrowRightIcon className="h-4 w-4 transition-transform duration-200 ease-republic group-hover:translate-x-1" data-id="element-222" data-mp="3mqs7usrdu6w8" />
          </Link>
        </li>)}
    </ul>;
}